import {
  FLAGS,
  useFeatureIsOn
} from '@komi-app/flags-sdk'
import { $creator } from '@komi-app/meta-creator'

export const useMiniSite = (): boolean => {
  const shouldRedirect = useFeatureIsOn(FLAGS.USE_MINI_SITE)
  const { pathname } = location
  
  if (!shouldRedirect)
    return false

  if (pathname.startsWith('/admin/modules') || pathname === '/admin') {
    location.pathname = $creator.MiniSite.Content.path
    return true
  }

  if (pathname.startsWith('/admin/header')){
    location.pathname = $creator.MiniSite.Header.path
    return true
  }

  if (pathname.startsWith('/admin/social-links')) {
    location.pathname = $creator.MiniSite.SocialLinks.path
    return true
  }

  if (pathname.startsWith('/admin/theme')) {
    location.pathname = $creator.MiniSite.Theme.path
    return true
  }

  if (pathname.startsWith('/admin/monetization')) {
    location.pathname = $creator.Monetization.path
    return true
  }

  return false
}

export default useMiniSite